import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AuditService } from 'app/audit/services/audit.service';
import { AuditTypeModel } from 'app/audit/models/audit-type.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Result } from 'app/core/models/result';
import { AuditListModel } from 'app/audit/models/audit-list.model';
import { ModuleService } from 'app/module/services/module.service';

@Component({
    selector: 'app-module-audit-add',
    templateUrl: './module-audit-add.component.html',
    styleUrls: ['./module-audit-add.component.css']
})
export class ModuleAuditAddComponent implements OnInit {
    errors: string[];
    auditTypes: AuditTypeModel[];
    audits: AuditListModel[];
    addAuditFrom: FormGroup;
    submitAttempt: boolean = false;
    @Input() moduleId: string;
    @Input() isEditMode: boolean = false;
    @Output() moduleAuditAdded: EventEmitter<string> = new EventEmitter<string>();

    constructor(
        private auditService: AuditService,
        private moduleService: ModuleService,
        private fb: FormBuilder,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
        this.getAuditTypes();
        this.getAudits();

        this.addAuditFrom = this.fb.group({
            moduleId: [this.moduleId],
            auditId: ['', Validators.required],
            auditTypeId: ['', Validators.required],
            order: ['', Validators.required]
        });
    }

    getAuditTypes(): void {
        this.auditService.getAuditTypes().subscribe(result => {
            this.auditTypes = result;
        });
    }

    getAudits(): void {
        this.auditService.getAll().subscribe(result => {
            this.audits = result;
        });
    }

    addAuditToModule(): void {
        this.submitAttempt = true;
        if (this.addAuditFrom.valid) {
            const formValue = this.addAuditFrom.value;
            formValue.moduleId = this.moduleId;

            this.auditService.addModuleToAudit(formValue).subscribe(
                result => {
                    this.moduleAuditAdded.emit(result);
                    this.addAuditFrom.reset();
                    this.submitAttempt = false;
                    this.modalService.dismissAll('saved');
                },
                error => {
                    this.errors = (<Result>error).errorList;
                    this.submitAttempt = false;
                }
            );
        }
    }

    openAddAudit(content) {
        this.modalService.open(content);
    }
}
